<button
  pgButton
  [type]="buttonModel?.type"
  [color]="buttonModel?.color"
  [id]="buttonModel?.id"
  [size]="buttonModel?.size"
  [scaleDownOnClick]="!buttonModel.disableScaleOnClick"
  [styleOverrides]="this.buttonModel"
  [disabled]="
    buttonModel?.disableIfFormInvalid && this.parentFormGroup && !this.formValid
  "
  (click)="handleButtonClicked($event)"
>
  <ng-container *ngIf="!buttonModel?.loading; else loadingTpl">
    <ng-container *ngIf="buttonModel?.leftIcon">
      <pg-icon>{{ buttonModel.leftIcon.iconName }}</pg-icon>
    </ng-container>
    {{ buttonModel.label }}
    <ng-container *ngIf="buttonModel?.rightIcon">
      <pg-icon>{{ buttonModel.rightIcon.iconName }}</pg-icon>
    </ng-container>
  </ng-container>
  <ng-template #loadingTpl>
    <pg-spinner></pg-spinner>
  </ng-template>
</button>
